import { Component, Input, OnInit } from '@angular/core';
import {
  DietDayModel,
  DietMealModel,
  MealRatio,
} from 'src/app/core/model/object/diet-model';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';

@Component({
  selector: 'app-plan-overview-notif',
  templateUrl: './plan-overview-notif.component.html',
  styleUrls: ['./plan-overview-notif.component.scss'],
})
export class PlanOverviewNotifComponent implements OnInit {
  @Input() show: boolean = false;
  @Input() meal: string;
  @Input() dietId: string;
  @Input() date: number;
  @Input() day: string;
  @Input() isPredeFined: boolean;
  @Input() cheatDaycount: number;
  title: string;
  constructor(
    private planShared: PlanShared,
    private planService: PlanService
  ) {}

  ngOnInit() {
    if (this.meal == 'breakfast') {
      this.title = 'صبحانه';
    } else if (this.meal == 'snack1') {
      this.title = ' میان‌وعده اول';
    } else if (this.meal == 'lunch') {
      this.title = 'ناهار';
    } else if (this.meal == 'snack2') {
      this.title = ' میان‌وعده دوم';
    } else if (this.meal == 'snack3') {
      this.title = ' میان‌وعده سوم';
    }
  }
  async goMealPage() {
    const selected = this.planShared.selectedDietDay.meals.findIndex(
      (v) => v.meal == this.meal
    );
    await this.planShared.saveRatios.next(selected);

    const day = this.planShared.selectedDietDay.meals[selected];
    this.planShared.selectedMeal = day;
    this.planService.goToMealDetail(
      this.dietId,
      this.day,
      this.isPredeFined,
      this.cheatDaycount
    );
  }
}
